import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CityService } from './services/city.service';
import { FilterPipe } from './services/FilterPipe';
import { SafePipe } from './services/SafePipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import {AppRoutingModule} from './app-routing.module'
import { LightboxModule } from 'angular2-lightbox';
import { BrowserXhr, HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgProgressModule, NgProgressInterceptor } from 'ngx-progressbar';
import {SocketProvider} from './services/socket.service';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatTableDataSource,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
} from '@angular/material';
import { MainComponent } from './component/main/main.component';
import { } from '@types/googlemaps';
import { MapComponent } from './component/map/map.component';
import { PlaceComponent} from './component/Place/place.component'
import { TableComponent } from './component/table/table.component';
import { placeRowComponent } from './component/blocks/placeRow/placeRow.component';
import { HeaderComponent } from './component/blocks/header/header.component';
import {AboutComponent} from './component/About/about.component';
import {StepsComponent} from './component/Steps/steps.component';
import {ContactUsComponent} from './component/contactus/contactus.component';
import{iWindowComponent} from './component/blocks/infoWindow/iWindow.component';
//import { ChartsModule } from 'ng2-charts/ng2-charts';
import {ServiceComponent } from './component/Service/service.component';
import { TableHeaderComponent } from './component/blocks/table-header/table-header.component';
import { FooterComponent } from './component/blocks/footer/footer.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
export function socketProviderFactory(provider: SocketProvider) {
    return () => provider.load();
  }

@NgModule({
    providers: [CityService, {provide: HTTP_INTERCEPTORS, useClass: NgProgressInterceptor, multi: true },SocketProvider, 
        { provide: APP_INITIALIZER, useFactory: socketProviderFactory, deps: [SocketProvider], multi: true }],
    imports: [
        NgProgressModule,
        LightboxModule,
        NgbModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatStepperModule,
        HttpModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        DeviceDetectorModule.forRoot()
    ],
    entryComponents: [ ContactUsComponent ,iWindowComponent],
    declarations: [
        AppComponent,
        iWindowComponent,
        ContactUsComponent,
        placeRowComponent,
        HeaderComponent,
        MainComponent,
        MapComponent,
        TableComponent,
        PlaceComponent,
        FilterPipe,
        SafePipe,
        AboutComponent ,
        StepsComponent,
        ServiceComponent,
        TableHeaderComponent,
        FooterComponent
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts